import axios from "axios";


export const http7001 = axios.create({
    baseURL: process.env.REACT_APP_LANGUAGE_ENDPOINT,
  });